import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const generatePageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    // Determine the range of page numbers to show
    let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    // Adjust start and end if they go out of bounds
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    // Add the first page and ellipsis if necessary
    if (startPage > 1) {
      pages.push(
        <li key={1}>
          <Link
            to="#"
            onClick={() => onPageChange(1)}
            className="size-[40px] inline-flex justify-center items-center text-slate-400 hover:text-white bg-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500"
          >
            1
          </Link>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="text-slate-400 size-[40px] inline-flex justify-center items-center">
            ...
          </li>
        );
      }
    }

    // Add the page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i}>
          <Link
            to="#"
            onClick={() => onPageChange(i)}
            className={`size-[40px] inline-flex justify-center items-center ${
              currentPage === i ? 'text-white bg-orange-500 border border-orange-500' : 'text-slate-400 hover:text-white bg-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500'
            }`}
          >
            {i}
          </Link>
        </li>
      );
    }

    // Add the last page and ellipsis if necessary
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="text-slate-400 size-[40px] inline-flex justify-center items-center">
            ...
          </li>
        );
      }
      pages.push(
        <li key={totalPages}>
          <Link
            to="#"
            onClick={() => onPageChange(totalPages)}
            className="size-[40px] inline-flex justify-center items-center text-slate-400 hover:text-white bg-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500"
          >
            {totalPages}
          </Link>
        </li>
      );
    }

    return pages;
  };

  return (
    <div className="grid md:grid-cols-12 grid-cols-1 mt-10">
      <div className="md:col-span-12 text-center">
        <nav aria-label="Page navigation example">
          <ul className="inline-flex items-center -space-x-px">
            <li>
              <Link
                to="#"
                onClick={() => onPageChange(currentPage - 1)}
                className={`size-[40px] inline-flex justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-s-3xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500 ${currentPage === 1 ? 'pointer-events-none opacity-50' : ''}`}
              >
                <FiChevronLeft className="size-5 rtl:rotate-180 rtl:-mt-1" />
              </Link>
            </li>
            {generatePageNumbers()}
            <li>
              <Link
                to="#"
                onClick={() => onPageChange(currentPage + 1)}
                className={`size-[40px] inline-flex justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-e-3xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500 ${currentPage === totalPages ? 'pointer-events-none opacity-50' : ''}`}
              >
                <FiChevronRight className="size-5 rtl:rotate-180 rtl:-mt-1" />
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
